import React from 'react'
import clsx from 'clsx'

import MedicalUserSVG from '../../svg/MedicalUserSVG'
import EngineeringUserSVG from '../../svg/EngineeringUserSVG'

/**
 * Step1UserType Component
 *
 * First step of signup: User selects their profile type
 *
 * Il profilo 'learner' e' disabilitato (ticket 6aaba029): solo il bottone
 * qui e' nascosto, il backend continua a supportarlo per gli account
 * esistenti (DIGISCAN_WEB/models/Auth.py::USER_TYPES invariato).
 */
const userTypes = [
  {
    id: 'medical',
    title: 'I am a medical user',
    description: 'Healthcare professional or medical researcher',
    Icon: MedicalUserSVG,
    selectedStyle: {
      borderColor: '#60a5fa',
      backgroundColor: 'rgba(59, 130, 246, 0.25)',
    },
    checkColor: '#60a5fa',
  },
  {
    id: 'engineering',
    title: 'I am an engineering user',
    description: 'Focused on fluid flows and biomechanical simulations',
    Icon: EngineeringUserSVG,
    selectedStyle: {
      borderColor: '#c084fc',
      backgroundColor: 'rgba(168, 85, 247, 0.25)',
    },
    checkColor: '#c084fc',
  },
]

const Step1UserType = ({ selectedType, onSelect, onNext }) => {
  const renderUserTypeButton = (type) => (
    <button
      key={type.id}
      onClick={() => onSelect(type.id)}
      className="w-full p-6 border-2 rounded-lg text-left transition-all hover:shadow-lg"
      style={
        selectedType === type.id
          ? type.selectedStyle
          : {
              borderColor: 'rgba(255,255,255,0.2)',
              backgroundColor: 'rgba(255,255,255,0.05)',
            }
      }
    >
      <div className="flex items-start space-x-4">
        <type.Icon styles="w-16 h-16 flex-shrink-0" forceColor="#ffffff" />
        <div className="flex-1">
          <h3 className="text-lg font-semibold mb-1 text-white">
            {type.title}
          </h3>
          <p className="text-sm text-gray-300">{type.description}</p>
        </div>
        {selectedType === type.id && (
          <div>
            <svg className="w-6 h-6" fill={type.checkColor} viewBox="0 0 20 20">
              <path
                fillRule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                clipRule="evenodd"
              />
            </svg>
          </div>
        )}
      </div>
    </button>
  )

  return (
    <div className="max-w-4xl mx-auto">
      <p className="text-center text-white text-opacity-90 mb-8 mt-2">
        Tell us about yourself to personalize your experience
      </p>

      <div className="grid grid-cols-1 gap-4 mb-8">
        {userTypes.map((type) => renderUserTypeButton(type))}
      </div>

      <div className="flex justify-center">
        <button
          onClick={onNext}
          disabled={!selectedType}
          className={clsx(
            'px-6 py-3 border border-white/30 rounded-lg text-white transition-colors',
            {
              'hover:bg-white/10 cursor-pointer': selectedType,
              'opacity-60 cursor-not-allowed': !selectedType,
            }
          )}
        >
          Next: Select Modules →
        </button>
      </div>
    </div>
  )
}

export default Step1UserType
